
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-integrations/webengage",
      function () {
        return require("private-next-pages/whatsapp-integrations/webengage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-integrations/webengage"])
      });
    }
  